import {
  EApplicationStateType,
  EAssetCondition,
  EAssetType,
  EDocType,
  EFarmArrangement,
  EIrrigation,
  EOrderState,
  ESidePanelView,
  ETraderTradeType,
} from 'constants/index';

export type ID = string | number;

export enum EGPAY_ACCOUNT_TYPE {
  NOMINATED_ACCOUNT = 'NOMINATED_ACCOUNT',
  TPFM = 'TPFM',
  KHULA_FEES = 'KHULA_FEES',
}

export enum EFarmLayer {
  NDVI = 'NDVI',
  MOISTURE = 'MOISTURE',
  CHLOROPHYLL = 'CHLOROPHYLL',
  RGB = 'RGB',
}
export interface ICOA {
  description: string;
  _id: string;
  account_code: string;
  account_name: string;
  account_type: string;
  tax_code: string;
  balance: number;
  parent_account_id: string;
  created_at: string;
  updated_at: string;
  createdAt: string;
  updatedAt: string;
}
export interface IcoaTransactions {
  _id: string;
  description: string;
  amount: number;
  date: string;
  customer_id: string;
  account_id: string;
  is_allocated: boolean;
  flag_reason: string;
  created_at: string;
  updated_at: string;
  createdAt: string;
  updatedAt: string;
}
export interface IRouteScreenProps {
  history?: any;
  location?: any;
  match?: any;
}
export interface IGenericType {
  id?: any;
  name?: string;
  type?: string;
  category?: number;
}
export interface IAuthResponse {
  success: boolean;
  verified?: boolean;
  token?: string;
  message?: string;
  state?: number;
  active?: number;
}
export interface IGenericResponse {
  success?: boolean;
  message?: string;
  reference?: string;
}
export interface IVoucherTransactions {
  insertedOn: Date;
  state: number;
  price: number;
  id: number;
  product: IProductDetails;
}

export interface IFarmProfile {
  userType?: any;
  numberOfEmployees?: any;
  corporateRegNumber?: any;
  businessType?: any;
  beeScore?: any;
  farmName?: any;
  farmerName?: any;
  businessTypes?: any;
  turnover?: any;
  race?: any;
  gender?: any;
  farmFenced?: any;
  farmPloughed?: any;
  landOwnership?: any;
  leaseLength?: any;
  farmSize?: any;
  irrigationHectares?: any;
  irrigationOther?: any;
  irrigationTypes?: any;
  soilTest?: any;
  soilTestInterest?: any;
  sprayingProgram?: any;
  fertilizationProgram?: any;
  infrastructureTypes?: any;
  bankOptions?: any;
  fundingOptions?: any;
  financeOptions?: any;
  lookingForFinance?: any;
  waterTests?: any;
  waterDetails?: any;
  waterOther?: any;
  waterRights?: any;
  waterCapacity?: any;
  otherCertification?: any;
  activeCertification?: any;
  pastCertification?: any;
  experienceList?: any;
  mentorshipProgram?: any;
  farmingYears?: any;
  electricity?: any;
  insurance?: any;
}
export interface ISupplierUserProfile {
  id: string;
  name: string;
  surname: string;
  email: string;
  phone: string;
  address?: string;
  pictureUrl?: string;
  latlong?: string;
  isActive: boolean;
  depot?: IDepot;
  depots?: IDepot[];
  invitationCode?: string;
  userId: string;
  company?: ISupplierCompanyProfile;
  brand?: IMainSupplierBrand;
  mainSupplier?: IMainSupplier;
  isAdmin: boolean;
  isKhulaAdmin: boolean;
  companyPermissions: ISupplierCompanyPermissions;
  permissions: ISupplierUserPermission[];
  // eslint-disable-next-line @typescript-eslint/naming-convention
  isAECI: boolean;
  isCommodityGroup: boolean;
}

export interface IDepot {
  id: number;
  nulandisId: number;
  code: string;
  name: string;
  isActive: boolean;
  contact: string;
  phone: string;
  address1: string;
  address2: string;
  address3: string;
  address4: string;
  address5: string;
  latitude: string;
  longitude: string;
  mainSupplier?: IMainSupplier;
}
export interface ISupplierUserInput {
  id?: string;
  name?: string;
  surname?: string;
  email?: string;
  password?: string;
  phone?: string;
  address?: string;
  pictureUrl?: string;
  latlong?: string;
  isActive?: boolean;
  depotIds?: number[];
  isAdmin: boolean;
  brandSupplierId?: string;
  companyId?: string;
}
export interface ISupplierCompanyProfile {
  id: string;
  name: string;
  tradingName?: string;
  image?: string;
  location?: string;
  addressLine1?: string;
  addressLine2?: string;
  city?: string;
  province?: string;
  areaCode?: string;
  depotPriceList: boolean;
  freeDeliveryOrderTotal?: number;
  marginPercentage?: number;
  bankId?: string;
  bank: IGenericType;
  bankAccountTypeId?: string;
  bankAccountType: IGenericType;
  bankAccountNumber?: string;
  bankBranchCode?: string;
  gpayEntityId?: string;
  vatNumber?: string;
  taxNumber?: string;
}
export type ICompanyInput = Partial<ISupplierCompanyProfile> & {
  companyId: string;
  brandSupplierId: string;
  mainSupplierId: string;
};
export interface IMainSupplier {
  id: string;
  image: string;
  name: string;
  company?: ISupplierCompanyProfile;
  marginPercentage?: number;
}
export interface IMainSupplierBrand {
  id: string;
  name: string;
  image?: string;
  supplierCode?: string;
  company?: ISupplierCompanyProfile;
}
export interface IProductDetails {
  id: number;
  name: string;
  price: number;
  category: string;
  date?: Date;
  stockCode: string;
  size: number;
  measurement: string;
  productType: string;
  lastUpdated: Date;
  produce?: string;
  bugs?: string;
  activeIngredient: string;
  tradeName?: string;
  variety?: string;
}
export interface IVoucherDetails {
  id: number;
  value: number;
  assignedAmount: number;
  farmer: IFarmProfile;
  categories: Array<string>;
  transactions: Array<IVoucherTransactions>;
  paid?: boolean;
  farmerDetails: IFarmerProfile;
}
export interface IVoucherInvoice {
  id: number;
  insertedOn: Date;
  updatedDate?: Date;
  paid: boolean;
  assignedAmount: number;
  vouchers: Array<IVoucherDetails>;
}
export interface IFarmerProfile {
  id: number;
  name: string;
  surname: string;
  image: string;
  farmProfileData: IFarmerProfileData;
  coverPhoto: string;
  createdOn: string;
  updatedOn: string;
  rating: number;
  totalTraded: number;
  deliveriesCompleted: number;
  produce: Array<IProduceLink>;
  distance: string;
  preferred: boolean;
  voucherStatus?: boolean;
  farmSize?: number;
  numberOfVouchers?: number;
}

export interface IFarmerProfileData {
  farmLatLong: string;
  farmName: string;
  farmType: string;
  province: string;
  farmSize: string;
  farmPloughed: string;
  waterTestInLastTwelveMonths: string;
  soilTestInLastTwelveMonths: boolean;
  turnover: string;
  landOwnership: string;
  certification: Array<IGenericType>;
  funding: Array<IGenericType>;
  infrastructure: Array<IGenericType>;
  irrigation: Array<IGenericType>;
}
export interface IProduceLink {
  produce: IProduce;
}
export interface IProduce {
  id: string;
  name: string;
  category: string;
  variety: IGenericType[];
}

export interface IVoucherTypeCreation {
  voucherLevel: number;
  key: any;
  name?: string;
  image?: string;
  category?: string;
  description?: string;
}
export interface IVoucherInCreation {
  voucherType: Array<IVoucherTypeCreation>;
  amount: number;
  farmers: Array<IFarmerProfile>;
}
export interface IProductSubcategory {
  key: any;
  voucherLevel: number;
  category: string;
  description: string;
}
export interface IProductCategory {
  name: string;
  id: any;
  image: string;
  voucherLevel: number;
  key: any;
  subCategory?: Array<IProductSubcategory>;
}
export interface ICartItem {
  category: Array<IVoucherTypeCreation>;
  amount: number;
  farmer: IFarmerProfile;
}

export interface IPanelTypeInformation {
  panelType: ESidePanelView;
  data?: any;
  readOnly?: boolean; // Optional flag for read-only mode
}
export interface ISidePanel {
  open: boolean;
  panelInfo?: IPanelTypeInformation;
  withoutOverlay?: boolean;
  // Optional: lifecycle state for edit panels. Values: 'idle' | 'editing' | 'saved'
  editState?: 'idle' | 'editing' | 'saved';
  // Optional: store updated company data from sidepanel edits
  updatedCompany?: ISupplierCompanyProfile;
}

export interface IFarmInputInvoice {
  id: number;
  invoiceNumber: string;
  insertedDate: string;
  updatedDate: string;
  isPaid: boolean;
  latitude: string;
  longitude: string;
  address: string;
  total: number;
  outstanding: number;
  farmer: IFarmer;
  orders: IFarmInputOrder[];
  depot: IDepot;
  deliveryType: 'Delivery' | 'Collection';
  documentUrl?: string;
  proformaInvoiceUrl?: string;
  logisticsCost?: number;
  orderStatus: [
    {
      index: number;
      status: OrderStep;
      description: string;
    },
  ];
  currOrderStatus: {
    index: number;
    status: OrderStep;
    description: string;
  };
  vatExempt?: boolean;
  state: EOrderState;
}

export type OrderStep = 'PENDING' | 'IN_PROGRESS' | 'COMPLETED';

export interface IFarmInputQuote {
  id: number;
  quoteNumber: string;
  insertedDate: string;
  updateDate: string;
  latitude: string;
  longitude: string;
  address: string;
  total: number;
  farmer: IFarmer;
  lineItems: IFarmInputQuoteLineItem[];
  depot: IDepot;
  isForDelivery: boolean;
  deliveryType: 'Delivery' | 'Collection';
  state: QuotationStatus;
  formattedState: FormattedQuotationStatus;
  isExpired: boolean;
  contactPersonName?: string;
  contactPersonPhoneNumber?: string;
  deliveryInstructions?: string;
  logisticsCost?: number;
  vatExempt?: boolean;
}

export type QuotationStatus =
  | 'REJECTED'
  | 'PENDING'
  | 'IN_REVIEW'
  | 'PENDING_FARMER_REVIEW'
  | 'ACCEPTED';

export type FormattedQuotationStatus =
  | 'Rejected'
  | 'Pending'
  | 'In Review'
  | 'Pending Farmer Review'
  | 'Accepted';

export interface IFarmInputQuoteLineItem {
  id: number;
  retailPrice: number;
  price: number;
  costPrice?: number;
  originalQuantity: number;
  quantity: number;
  product: IFarmInputProduct;
}

export interface IFarmerCompany {
  vatExempt?: boolean;
}

export interface IFarmer {
  id: number;
  name: string;
  surname: string;
  email: string;
  phone: string;
  image: string;
  address?: string;
  farm?: IFarm;
  userId?: string;
  totalTraded?: number;
  company?: IFarmerCompany;
  user?: {
    verified?: boolean;
  };
}

export interface IFarm {
  polygons: any;
  id: number;
  name: string;
  farmName: string;
  sizeHectares: string;
  type: string;
  turnover: string;
  numberOfEmployees: string;
  province: string;
  latLong: string;
  farmPolygons: IPolygonData[];
  fields: IPolygonData[];
}
interface IPolygonProduce {
  id: string;
  name: string;
}

interface IPolygonInfo {
  hectares: number;
  produce: IPolygonProduce;
  fieldName: string;
  variety: string | null;
  plantedOn?: string | null;
  plantPopulation: number;
  irrigation: string | null;
  expectedYield: number;
  plantingDate?: string | null;
  plannedPlantingDate?: string | null;
  rowSpacingCm?: number | null;
  seedSpacingCm?: number | null;
  plantingDepthCm?: number | null;
  harvestStartDate?: string | null;
  harvestEndDate?: string | null;
}

interface IPolygonSoilData {
  soilType: string | null;
  P: number;
  K: number;
  Ca: number;
  Mg: number;
  Na: number;
  pH: number;
  cations: number;
  anions: number;
  exchangeableAcidity: number;
}

export interface IPolygonData {
  id?: string;
  info?: IPolygonInfo;
  soilData?: IPolygonSoilData;
  coordinates: ICoordinateInput[];
  risks?: Array<
    | string
    | {
        analysisDate?: string | number | null;
        date?: string | number | null;
        ndviRiskLevel?: string | null;
        moistureRiskLevel?: string | null;
        clRiskLevel?: string | null;
      }
  >;
  availableLayers?: Array<{
    date?: string | number | null;
    layers?: Array<{
      layer?: string;
      url?: string | null;
    }>;
  }>;
  availableDroneLayers?: Array<{
    createdAt: string;
    analysisDate: string;
    rootLayerPathLink: string;
  }>;
}

export interface IFarmNoteLog {
  id?: string;
  noteDate?: string | null;
  noteText?: string | null;
  title?: string | null;
  comment?: string | null;
  lat?: number | null;
  long?: number | null;
  isCritical?: boolean | null;
  createdAt?: string | null;
  updatedAt?: string | null;
  images?: IFarmNoteImage[] | null;
}

export interface IFarmNoteImage {
  id?: string;
  imageUrl?: string | null;
  caption?: string | null;
}

export interface IGrowthObservationLog {
  id?: string;
  noteId?: string | null;
  observationDate?: string | null;
  cropGrowthStage?: string | null;
  averagePlantHeightCm?: number | null;
  leafAreaIndex?: number | null;
  overallCropHealthRating?: number | null;
  pestAndDiseasePresence?: string | null;
  weedPressure?: string | null;
  floweringIntensity?: string | null;
  fruitSetIntensity?: string | null;
  estimatedYieldKgha?: number | null;
  germinationDate?: string | null;
  expectedGerminationRate?: number | null;
  estimatedYield?: number | null;
  yieldEstimate?: number | null;
  plantHeightCm?: number | null;
  germinationRatePct?: number | null;
  seedlingVigorScale?: number | null;
  rootLengthScale?: number | null;
  cropMaturityAssessment?: string | null;
  uniformityOfMaturityScale?: number | null;
  leavesPerPlant?: number | null;
  floweringUniformityScale?: number | null;
  fruitSetPercent?: number | null;
  fruitSetUniformityScale?: string | null;
  fruitAvgLengthCm?: number | null;
  pctCropReadyForHarvest?: number | null;
  createdAt?: string | null;
  updatedAt?: string | null;
}

export interface IIssueLogRecord {
  id?: string;
  noteId?: string | null;
  issueDate?: string | null;
  issueType?: string | null;
  description?: string | null;
  severityScale?: number | null;
  affectedAreaHectares?: number | null;
  controlMeasuresApplied?: string | null;
  preventativeMeasuresTaken?: string | null;
  curativeMeasuresTaken?: string | null;
  issueStatus?: string | null;
  issueDuringHarvest?: boolean | null;
  createdAt?: string | null;
  updatedAt?: string | null;
}

export interface IManagementLogRecord {
  id?: string;
  noteId?: string | null;
  logDate?: string | null;
  activityType?: string | null;
  inputsUsed?: string | null;
  fertilizerType?: string | null;
  applicationRateKgha?: number | null;
  laborHours?: number | null;
  machineryUsed?: string | null;
  irrigationFrequency?: string | null;
  irrigationVolume?: number | null;
  weatherConditions?: string | null;
  waterStressSigns?: string | null;
  initialTreatmentActions?: string | null;
  createdAt?: string | null;
  updatedAt?: string | null;
}

export interface IHarvestSummaryRecord {
  id?: string;
  noteId?: string | null;
  harvestDate?: string | null;
  totalHarvestedQuantityKg?: number | null;
  avgYieldPerHectareKgha?: number | null;
  harvestMethod?: string | null;
  pctFirstGradeProduce?: number | null;
  commonQualityIssues?: string | null;
  harvestEfficiencyScale?: number | null;
  qualityGradesDistribution?: string | null;
  laborersUsed?: number | null;
  equipmentUsed?: string | null;
  initialProcessingSteps?: string | null;
  storageConditions?: string | null;
  transportationArrangements?: string | null;
  createdAt?: string | null;
  updatedAt?: string | null;
}

export interface IPostHarvestReviewRecord {
  id?: string;
  noteId?: string | null;
  reviewDate?: string | null;
  marketPricesAchieved?: number | null;
  costOfProductionAnalysis?: number | null;
  profitabilityAssessment?: string | null;
  laborEfficiencyChallenges?: string | null;
  equipmentPerformanceIssues?: string | null;
  recommendationsForNextSeason?: string | null;
  areasForImprovement?: string | null;
  keySuccesses?: string | null;
  comparisonWithExpectedYields?: string | null;
  pestDiseaseEffectiveness?: string | null;
  nutrientMgmtEffectiveness?: string | null;
  adjustmentsMadeDuringSeason?: string | null;
  impactOnYieldQuality?: string | null;
  lessonsLearned?: string | null;
  createdAt?: string | null;
  updatedAt?: string | null;
}

export interface IFarmFieldLogData {
  id?: string;
  info?: {
    hectares?: number;
    fieldName?: string;
    variety?: string | null;
    plantedOn?: string | null;
    plantPopulation?: number;
    irrigation?: string | null;
    expectedYield?: number;
    produce?: {
      id?: string;
      name?: string;
    };
  };
  notes?: IFarmNoteLog[];
  growthObservations?: IGrowthObservationLog[];
  issueLogs?: IIssueLogRecord[];
  managementLogs?: IManagementLogRecord[];
  harvestSummaries?: IHarvestSummaryRecord[];
  postHarvestReviews?: IPostHarvestReviewRecord[];
  soilAssessments?: ISoilAssessmentRecord[];
}

export interface ISoilAssessmentRecord {
  id?: string | number;
  noteId?: string | number | null;
  soilType?: string | null;
  soilStructure?: string | null;
  hardpanPresence?: boolean | null;
  organicMatterPct?: number | null;
  pH?: number | null;
  P?: number | null;
  K?: number | null;
  Ca?: number | null;
  Mg?: number | null;
  Na?: number | null;
  Zn?: number | null;
  Mn?: number | null;
  Cu?: number | null;
  exchangeableAcidity?: number | null;
  totalCations?: number | null;
  anions?: number | null;
  soilAmendmentsNeeded?: string | null;
  suggestedCropVarieties?: string | null;
  pestWeedStrategies?: string | null;
  createdAt?: string | null;
  updatedAt?: string | null;
}
export interface IFarmInputOrder {
  id: number;
  product: IFarmInputProduct;
  quantity: number;
  price: number;
  isDelivered: boolean;
  dueDate: string;
  logisticsTypeName?:
    | 'Pick Up'
    | 'Free Delivery'
    | 'Courier Guy Delivery'
    | 'Supplier Custom';
  farmer?: IFarmer;
  totalCost?: number;
  orderStatus?: any;
  insertedOn?: string;
}

export interface IFarmInputProduct {
  id: number;
  name: string;
  costPrice?: number;
  price: number;
  category: string;
  stockCode: string;
  size: number;
  measurement: string;
  grade: string;
  isActive: boolean;
  activeIngredient?: string;
  tradeName: string;
  image?: string;
  productType: string;
  labelLink?: string;
  mainCategoryId?: string | number;
  subCategoryId?: string;
  subCategoryName?: string;
  depotInfo?: IFarmInputProductDepotInfo;
  provincialRestrictions: IProvince[];
  lengthCm?: number;
  widthCm?: number;
  heightCm?: number;
  weightKg?: number;
  promotedPrice?: number;
  description: string;
  relatedProducts: IFarmInputProduct[];
  bugs: IBug[];
  mainSupplier?: IMainSupplier;
  brand?: IMainSupplierBrand;
}

export interface IFarmInputProductDepotInfo {
  id: string;
  depotId: string;
  depot: IDepot;
  productId: string;
  product: IFarmInputProduct;
  costPrice?: number;
  price?: number;
  minOrderQuantity?: number;
  minOrderQuantityFreeDelivery?: number;
  stockOnHand?: number;
  isActive: boolean;
}

export interface IFarmInputProductDepotInfoInput {
  id?: string;
  isActive: boolean;
  depotId: string;
  productId: string;
  stockOnHand?: number;
  minOrderQuantityFreeDelivery?: number;
  minOrderQuantity?: number;
  price?: number;
  costPrice?: number;
}

export interface IFarmInputProductInput {
  id?: number | string;
  name: string;
  price: number;
  costPrice?: number;
  category: string; // sub_category.code
  stockCode: string;
  size: number;
  measurement: string; // no predefined set of options
  grade: string; // no idea what this is. db lists A, B, C etc. Set empty string
  activeIngredient?: string;
  tradeName?: string;
  image?: string;
  labelLink?: string;
  mainCategoryId?: string | number;
  subCategoryId?: string | number; // input_sub_sub_category.id
  subCategoryName?: string; // input_sub_sub_category.name
  isActive: boolean;
  mainInputSupplierId: string | number;
  brandSupplierId: string | number;
  provincialRestrictions: string[];
  lengthCm?: number;
  widthCm?: number;
  heightCm?: number;
  weightKg?: number;
  description: string;
  relatedProducts: (number | string)[];
  bugs: (number | string)[];
}

export interface IProductPromoteInput {
  promotionalValue: number;
  promotionalStartDate: Date;
  promotionalEndDate: Date;
  inputProductId: number;
  depots: number[];
}

export interface IInputMessage {
  id: string;
  invoiceId: string;
  messageType: 'TEXT' | 'IMAGE' | 'PRODUCT';
  date: Date;
  isRead: boolean;
  senderType: 'FARMER' | 'SUPPLIER';
  textData?: {
    id: string;
    message: string;
  };
  productData?: {
    id: string;
    orderId: string;
    response: 'PENDING' | 'ACCEPTED' | 'REIMBURSEMENT';
    previousProduct: IFarmInputProduct;
    previousQuantity: number;
    previousPrice: number;
    replacementProduct: IFarmInputProduct;
    quantity: number;
    price: number;
  };
}

export interface IOrderReplacement {
  invoiceId: number;
  orderId: number;
  replacementProductStockCode: string;
  quantity: number;
  price: number;
}

export interface IQuoteMessage {
  id: string;
  quoteId: string;
  messageType: 'TEXT' | 'IMAGE' | 'PRODUCT';
  date: Date;
  message: string;
  senderType: 'FARMER' | 'SUPPLIER';
}

export interface IDepotStatistics {
  startDate: Date;
  endDate: Date;
  depots?: IDepot[];
  invoicesTotal: number;
  invoicesCount: number;
  paidInvoicesTotal: number;
  paidInvoicesCount: number;
  unpaidInvoicesTotal: number;
  unpaidInvoicesCount: number;
  completedInvoicesTotal: number;
  completedInvoicesCount: number;
  incompleteInvoicesTotal: number;
  incompleteInvoicesCount: number;
  paidAndIncompleteInvoicesTotal: number;
  paidAndIncompleteInvoicesCount: number;
  quotesTotal: number;
  quotesCount: number;
  activePendingQuotesTotal: number;
  activePendingQuotesCount: number;
  pendingQuotesTotal: number;
  pendingQuotesCount: number;
  completeQuotesTotal: number;
  completeQuotesCount: number;
  expiredQuotesTotal: number;
  expiredQuotesCount: number;
  rejectedQuotesTotal: number;
  rejectedQuotesCount: number;
}

/* ------------------------------------------------------------------ */
/*  Add-ons are **optional** so existing code keeps compiling          */
/* ------------------------------------------------------------------ */
/* ------------------------------------------------------------------ */
/*  Shared DTOs / contract                                            */
/* ------------------------------------------------------------------ */
export interface ITimeSeriesPoint {
  /** ISO date string (“YYYY-MM-DD”) */
  date: string;
  /** canonical key (new BE)        */
  count: number;
  /** legacy key (old BE)           */
  numberOfViews?: number;
}

export interface ISupplierAnalytics {
  /* ───────── views ───────── */
  /** daily *store* views – new canonical field */
  storeViews?: ITimeSeriesPoint[];

  /** ← legacy alias (optional) */
  userViewData?: {date: string; numberOfViews: number}[];

  /** daily *product* views – new canonical field */
  productViews?: ITimeSeriesPoint[];

  /** ← legacy alias occasionally returned */
  productViewsData?: {date: string; numberOfViews: number}[];

  /* ───────── top products ───────── */
  mostPopular: {
    productId: number;
    /** canonical key (new BE) */
    units?: number;
    /** legacy fallback        */
    numberOfViews?: number;
    /** hydrated client-side */
    product?: IFarmInputProduct;
  }[];
}

export interface IInputQuoteProductInput {
  id?: string | number;
  stockCode: string;
  price: number;
  costPrice?: number;
  quantity: number;
}

export interface IInputQuoteAddress {
  address: string;
  latitude: string;
  longitude: string;
  deportId?: number;
}

export interface IUser {
  id: string;
  username: string;
  name: string;
  surname: string;
  email: string;
  phone: string;
  address: string;
  latLong: string;
  image: string;
  company?: ISupplierCompanyProfile;
  farmer: IFarmer;
  hasPin: boolean;
}

export interface ILayerResponse {
  url: string;
  error: string;
  riskLevel: string;
  layer: EFarmLayer;
}

export interface ILayerHistoryResponse {
  fieldId: string | number;
  analysisDate?: string | null;
  layers: ILayerResponse[];
}
export interface IPolygonInput {
  info?: IPolygonInfoInput;
  soilData?: IPolygonSoilDataInput;
  coordinates: ICoordinateInput[];
}
export interface ICoordinateInput {
  lat: number;
  lng: number;
}

export interface IPolygonSoilDataInput {
  dateCollected?: string;
  soilType?: string;
  pH?: number;
  P?: number;
  K?: number;
  Ca?: number;
  Mg?: number;
  Na?: number;
  cations?: number;
  exchangeableAcidity?: number;
  anions?: number;
  Zn?: number;
  Mn?: number;
  Cu?: number;
}
export interface IPolygonInfoInput {
  hectares?: number;
  produceId?: string | number;
  variety?: string;
  plantedOn?: string;
  plantPopulation?: number;
  irrigation?: string;
  expectedYield: number;
  fieldName: string;
  plantingDate?: string;
  plannedPlantingDate?: string;
  rowSpacingCm?: number;
  seedSpacingCm?: number;
  plantingDepthCm?: number;
  harvestStartDate?: string;
  harvestEndDate?: string;
}

export interface ISupportCustomer {
  farmer: IFarmer;
  lastMessage?: ISupportMessage;
  farmerAccepted: boolean;
}

export interface ISupportCustomer2 {
  farmer: IFarmer;
  lastMessage?: ISupportMessage;
}

export interface ISupportMessage {
  id: string;
  date: Date;
  from: IUser;
  to: IUser;
  type: 'TEXT' | 'IMAGE' | 'REPLACEMENT_REQUEST' | 'FORM';
  message: string;
}

export type ICompletedSupportForm = ISupportMessage[];

export interface IRegion {
  address: string;
  latlong: string;
  country: string;
  province: string;
}

export interface ISupplierCompanyPermissions {
  customers: boolean;
  customerApplications: boolean;
  customerWallet: boolean;
  customerFieldsAndLayers: boolean;
  customerPrograms: boolean;
  products: boolean;
  productsGlobalViewOnly: boolean;
  quotes: boolean;
  orders: boolean;
  purchaseOrders: boolean;
  fundingApplications: boolean;
  fundingApplicationsViewOnly: boolean;
  programs: boolean;
  programsViewOnly: boolean;
  orderBundles: boolean;
  onboarding: boolean;
}

export type ISupplierCompanyPermissionsInput =
  Partial<ISupplierCompanyPermissions>;

export interface ISupplierUserPermission {
  id: number;
  name: string;
  description?: string;
}

export interface IFarmInputProductSubCategory {
  id: string;
  code: string;
  description: string;
}

export interface IWalletRestriction {
  id: number;
  name: string;
}

export interface IFarmInputProductSubSubCategory {
  id: string;
  name: string;
  description: string;
  subCategoryId: string;
  code: string;
}

export interface IProvince {
  id: string;
  name: string;
}

export type INotification = {
  id: string;
  date: Date;
  heading: string;
  body: string;
  link?: string;
  isRead?: boolean;
};

export interface ICreateQuoteResponse {
  success?: boolean;
  message?: string;
  reference?: string;
  quoteId: number;
}

export interface ICreateInvoiceResponse {
  success?: boolean;
  message?: string;
  reference?: string;
  invoiceId: number;
  proformaInvoiceId?: number | null;
}

export interface ISupportingDocument {
  id: number;
  title: string;
  url: string;
  createdDate: string;
}

export interface ISupportingDocumentInput {
  id?: number;
  title?: string;
  url?: string;
}

export interface IQuoteSupportingDocumentInput {
  id?: number;
  quoteId?: number;
  title?: string;
  url?: string;
}

export interface IInvoiceSupportingDocumentInput {
  id?: number;
  invoiceId?: number;
  title?: string;
  url?: string;
}

export interface IPurchaseOrderSupportingDocumentInput {
  id?: number;
  purchaseOrderId?: number;
  title?: string;
  url?: string;
}

export interface IDeliveryLocationInput {
  address?: string;
  latitude: string;
  longitude: String;
}

export interface IDeliveryProductInput {
  id: number;
  quantity: number;
}

export interface IDeliveryCost {
  success: boolean;
  message?: string;
  totalDeliveryCost?: number;
  originalTotalDeliveryCost?: number; // before discount
}

export interface IFarmerSignUpInput {
  username: string;
  password: string;
  name: string;
  surname: string;
  email: string;
  phone: string;
  registrationId: string;
  inviteCode?: string;
  farmName?: string;
}

export interface IFarmerAddressInput {
  address: string;
  latlng: string;
  province: string;
}

export interface IBug {
  id: string;
  name: string;
}

export interface IFarmInputPurchaseOrder {
  id: number;
  createdDate: string;
  updatedDate: string;
  mainSupplier?: IMainSupplier;
  invoice: IFarmInputInvoice;
  documentUrl?: string;
  total: number;
  orders: IFarmInputOrder[];
  statusUpdates: IFarmInputPurchaseOrderStatusUpdate[];
  gpayReceiptNo?: string;
  gpayWithdrawUser?: IUser;
  gpayWithdrawDate?: string;
  trackingReference?: string;
  expectedPaymentDate?: string;
  supportingDocuments?: IPurchaseOrderSupportingDocument[];
}

export interface IFarmInputPurchaseOrderStatusUpdate {
  id: number;
  date: string;
  user: IUser;
  status: IGenericType;
}

export interface IPurchaseOrderSupportingDocument {
  id: number;
  title: string;
  url: string;
  createdDate: string;
}

export interface IWalletStatement {
  accountNumber: string;
  fromDate: string;
  toDate: string;
  AccountBalance: number;
  OutstandingRequisitions: string;
  AvailableBalance: number;
  Statement: IWalletTransaction[];
}

export type IWalletTransaction = {
  TransactionDate: string;
  SyncDate: string;
  Description: string;
  Reference: string;
  SupplierBankReference?: string;
  Amount: number;
  inputsPurchaseOrder?: IFarmInputPurchaseOrder;
};

export interface IInvoiceBundle {
  id: number;
  insertedOn: string;
  updatedOn: string;
  farmer: IFarmer;
  total: number;
  outstanding: number;
  invoices: IFarmInputInvoice[];
  allInvoicesPaid: boolean;
}

export interface IFarmInputCreditNote {
  id: string;
  invoiceId: string;
  invoice: IFarmInputInvoice;
  insertedDate: string;
  updatedDate: string;
  documentUrl?: string;
  lineItems: IFarmInputCreditNoteLineItem[];
}

export interface IFarmInputCreditNoteLineItem {
  id: string;
  creditNoteId: string;
  orderId: string;
  order: IFarmInputOrder;
  quantity: number;
  price: number;
}

export interface IFarmInputCreditNoteLineItemInput {
  creditNoteId?: number | string;
  orderId: number | string;
  quantity: number;
  price: number;
}

export interface IFarmInputProgram {
  id: string;
  createdDate: string;
  updatedDate: string;
  active: boolean;
  farmerId: string;
  farmer: IFarmer;
  produceId: string;
  produce: IProduce;
  type: string;
  status: string;
  hectares: number;
  lines: IFarmInputProgramLine[];
}

export interface IFarmInputProgramInput {
  id?: string;
  active?: boolean;
  farmer?: IFarmer;
  farmerId?: string;
  farmerEmail?: string;
  produceId?: string;
  produce?: any;
  type?: string;
  status?: string;
  hectares?: number;
  createdDate?: string;
  updatedDate?: string;
  lines?: IFarmInputProgramLineInput[];
  fieldId?: string; // add this line so TS knows about fieldId
  fieldPolygon?: IPolygonData; // add this line so TS knows about fieldPolygon
}

export interface IFarmInputProgramLine {
  id: string;
  programId: string;
  program?: IFarmInputProgram;
  productId: string;
  product: IFarmInputProduct;

  when: string;
  quantity: number;
  PHI: number;

  applicationRate: number;
  applicationUnit: string;
  applicationType: string;
  applicationTypePerHectare: string;

  comment: string;
}

export interface IFarmInputProgramLineInput {
  id?: string;
  programId?: string;
  productId?: string;
  when?: string;
  quantity?: number;
  PHI?: number;
  applicationRate?: number;
  applicationUnit?: string;
  applicationType?: string;
  applicationTypePerHectare?: number;
  comment?: string;
  price?: number;
  product?: IProductDetails;
}

export interface ISoilData {
  K: number;
  P: number;
  Ca: number;
  Mg: number;
  Na: number;
  exchangeableAcidity: number;
  totalCations: number;
  ph: number;
}

export interface ISoilSampling {
  soilData: ISoilData;
  produce: string;
  programType?: string;
  farmSize: number;
  target: number;
  soilType: string;
  plantDate: string;
  wateringType: string;
  landType: string;
  location: string;
}

export interface IFdUser {
  id: string;
  externalId: string;
  name: string;
  surname: string;
  idNumber: string;
  creditScore: number;
  email: string;
  phoneNumber: string;
  creditScoreDocument: string;
  company?: IFdCompany;
  farm?: IFdFarm;
  applications: IFdApplicationType[];
  financials?: {vatNumber?: string; taxNumber?: string};
}

export interface IFdCompany {
  id: string;
  name: string;
  address: string;
  email: string;
  phoneNumber: string;
  applyingUser?: IFdUser;
  companyType?: IGenericType;
}

export interface IFdFarm {
  id: string;
  name: string;
  address: string;
  directions?: string;
  province?: string;
  description: string;
  numberOfLeasedHectares: number;
  leaseEndDate: number;
  ownedHectares: number;
  farmArrangement: EFarmArrangement;
  fullTimeFarming: boolean;
  irrigatedHectares: number;
  drylandHectares: number;
  applyingUser?: IFdUser;
  company?: IFdCompany;
  borehole?: boolean;
  dam?: boolean;
  river?: boolean;
  isLeased?: boolean;
  waterRights?: boolean;
  shortTermGoals?: string;
  longTermGoals?: string;
  landComposition?: string;
  workforceNumber?: number;
  workerTrust?: string;
  employmentBeforeAndAfter?: string;
}

export interface IFdApplicationType {
  id: string;
  createdAt: string;
  completedSectionsPercentage: number;
  incompleteSections: string[];
  applicationWallet?: number;
  applicationWalletAccount?: {
    id: string;
    customName?: string;
    accounts?: Array<{
      id: string;
      accountName?: string;
      accountNumber?: string;
      AvailableBalance?: number;
    }>;
  };
  applicationState: EApplicationStateType;
  applyingUser?: IFdUser;
  company?: IFdCompany;
  farm?: IFdFarm;
  completed: boolean;
  progress: number;
  subProgress: number;
  farmAsset: IFdFarmAssetType[];
  user?: IFdUser;
  fundingAsk?: IFdFundingAsk;
  productionPlans?: IFdProductionPlan[];
  team?: IFdFarmTeam[];
  customers?: IFdCustomerSupplier[];
  suppliers?: IFdFarmerSupplier[];
  farmRisk?: IFdFarmRisk[];
  financialPerformance?: IFdFinancialPerformance[];
  productionCosts?: IFdProductionCost[];
  operatingCosts?: IFdOperatingCost[];
  assets?: IFdFarmAssetType[];
  liabilities?: IFdLiability[];
  applicationDocuments?: IFdApplicationDocType[];
  productionHistory?: IFdProductionHistory[];
  applicationOwnerships?: IApplicationOwnershipType[];
}

export interface IFdAgreementDocType {
  id: string;
  agreement: string;
  agreementType: string;
}

export interface IFdApplicationAgreementType {
  id: string;
  agreementDoc?: IFdAgreementDocType;
  application?: IFdApplicationType;
  signatureUrl?: string;
  createdAt?: string;
}

/**
 * Ownership assignment for an FD application
 */
export interface IApplicationOwnershipType {
  id: string;
  application?: IFdApplicationType;
  owner?: ISupplierUserProfile;
  ownerId?: string;
  reportingTo?: ISupplierUserProfile;
  reportingToId?: string;
  notes?: string;
  state: string; // EApplicationOwnershipState on the API
  createdAt: string;
  updatedAt: string;
}

/**
 * DTO for creating/updating ownership
 */
export interface ICreateApplicationOwnershipDto {
  id?: string;
  applicationId: string;
  ownerId: string;
  reportingToId: string;
  state?: string; // EApplicationOwnershipState
  notes?: string;
  handOver?: boolean;
}

export interface IFdFarmAssetType {
  id: string;
  description: string;
  application?: IFdApplicationType;
  year: string;
  condition: EAssetCondition;
  value: number;
  farm?: IFdFarm;
  capacity: string;
  model: string;
  make: string;
  pricePerUnit: number;
  assetType: EAssetType;
  assetListItem?: IFdFarmAssetList;
}

export interface IFdFarmAssetList {
  id: string;
  name: string;
  description: string;
  assetCategory: string;
  assetUnit: string;
}

export interface IFdFundingAsk {
  id: string;
  applicationId?: number;
  fundingRequestCosts: IFdFundingRequestCost[];
  notes?: string;
  expectedFundingYear?: number;
  expectedFundingMonth?: number;
  application?: IFdApplicationType;
}

export interface IFdFundingRequestCost {
  id: string;
  label: string;
  cost: number; // Rands
}

export interface IFdProductionPlan {
  id: string;
  crop?: IFdCrop;
  numberOfHectares: number;
  estimatedYield: number;
  plantingDate: string;
  harvestYear?: number | null;
  harvestMonth?: number | null;
  notes: string;
  irrigation: EIrrigation;
  plantPopulation: number;
  estimatedPrice: number;
  areaOfDryLand: number;
  areaUnderIrrigation: number;
  application?: IFdApplicationType;
}

export interface IFdCrop {
  id: string;
  name: string;
  category?: IFdCropCategory;
  active: boolean;
}

export interface IFdCropCategory {
  id: string;
  name: string;
  priority: number;
}

export interface ITraderApplication {
  id: string;
  user?: IUser;
  company?: ISupplierCompanyProfile;
  farmer?: IFarmer;
  tradeType: ETraderTradeType;
  forms: ITradingForm[];
}

export interface ITradingForm {
  id: string;
  name: string;
  description: string;
  sections: TradingFormSection[];
  isComplete: boolean;
}

export interface TradingFormSection {
  id: string;
  name: string;
  fields: ITradingFormField[];
  isComplete: boolean;
}

export interface ITradingFormField {
  id: string;
  title: string;
  value: string;
}

export interface IFdFarmTeam {
  id: string;
  name: string;
  farmTeamRole: IFdFarmTeamRole;
  application?: IFdApplicationType;
}

export interface IFdFarmTeamRole {
  id: string;
  name: string;
  description: string;
}

export interface IFdFarmerSupplier {
  id: string;
  supplierList: IFdSupplierList[];
  supplierProductList: IFdSupplierProductList[];
  application?: IFdApplicationType;
}

export interface IFdSupplierList {
  id: string;
  name: string;
  products: IFdSupplierProductList[];
}

export interface IFdSupplierProductList {
  id: string;
  name: string;
}

export interface IFdCustomerSupplier {
  id: string;
  crop: IFdCrop;
  customer: IFdCustomer;
  application: IFdApplicationType;
}

export interface IFdCustomer {
  id: string;
  name: string;
}

export interface IFdFarmRisk {
  id: string;
  mitigation: string;
  problem: string;
  risk?: IGenericType;
  application?: IFdApplicationType;
}

export interface IFdFinancialPerformance {
  id: string;
  year: number;
  revenue: number;
  expenses: number;
  operatingCosts?: number;
  profit: number;
  financialYearEnd?: number | null;
  financialYearEndMonth?: number | null;
  company?: IFdCompany;
  notes?: string;
}

export interface IFdProductionCost {
  id: string;
  year: number;
  plantingDate: string;
  numberOfHectares: number;
  seed: number;
  fertiliser: number;
  chemical: number;
  notes?: string;
  crop?: IFdCrop;
  application?: IFdApplicationType;
}

export interface IFdOperatingCost {
  id: string;
  monthlyCosts: string;
  year: number;
  expense?: IGenericType;
  liability?: IGenericType;
  notes?: string;
  application?: IFdApplicationType;
}

export interface IFdLiability {
  id: string;
  creditLimitAmount: number;
  currentBalanceLimit: number;
  monthlyInstallmentAmount: number;
  inArrears: boolean;
  liabilityAccountType?: IGenericType;
  lender: string;
  application: IFdApplicationType;
}

export interface IFdApplicationDocType {
  id: string;
  documentType: EDocType;
  filePath: string;
  createdAt: string;
  updatedAt: string;
  application?: IFdApplicationType;
}

export interface IFdProductionHistory {
  id: number;
  crop?: IFdCrop;
  numberOfHectaresFarmed?: number | null;
  yieldPerHectare?: number | null;
  year?: number | null;
  farm?: IFdFarm;
  application?: IFdApplicationType;
  notes?: string | null;
  plantYear?: number | string | null;
  plantMonth?: number | string | null;
  harvestYear?: number | string | null;
  harvestMonth?: number | string | null;
}

export interface IGenericTypeItem {
  id?: number;
  type?: string;
  name?: string;
  otherType?: string;
  isActive: boolean;
  category?: any;
}

export interface ICompany {
  id: number;
  name: string;
  image: string;
  province: string;
  location?: string;
  tradingName?: string;
  addressLine1?: string;
  addressLine2?: string;
  city?: string;
  latlong?: string;
  vatNumber?: string;
  buyerType?: IGenericTypeItem;
  companyCategory?: IGenericTypeItem;
  companyType?: IGenericTypeItem;
  maxLeadTime?: number;
  load?: IGenericTypeItem;
  haveLogistics: Boolean;
  logisticsRegisteredForFood: Boolean;
  logisticsRefrigerated: Boolean;
  maxLogisticsTravel?: string;
  rebate?: string;
  startTradingTime?: string;
  endTradingTime?: string;
  openingTime?: string;
  closingTime?: string;
  deliveryStartTime?: string;
  deliveryEndTime?: string;
  certification?: Array<IGenericTypeItem>;
  directorsDocuments: [string];
  companyRegistrationNumber?: string;
  taxNumber?: string;
  areaCode?: string;
  bank?: IGenericTypeItem;
  bankAccountType?: IGenericTypeItem;
  bankAccountNumber?: string;
  bankBranchCode?: string;
  chepAccount?: string;
  taxClearanceLink?: string;
  bankConfirmationLink?: string;
  companyTermsOfTradeLink?: string;
  companyRegistrationLink?: string;
  gpayAccountBalance?: number;
}

export interface IClientProfile {
  id: number;
  company: ICompany;
}

export interface ITransactionItem {
  TransactionDate: string;
  SyncDate: string;
  Description: string;
  Reference: string;
  SupplierBankReference?: string;
  Amount: number;
}

export interface IGpayAccount {
  id: ID;
  accountType: EGPAY_ACCOUNT_TYPE;
  accountNumber: string;
  accountName: string;
  company: ICompany;
  client: IClientProfile;
  fromDate: string;
  toDate: string;
  AccountBalance: number;
  OutstandingRequisitions: string;
  AvailableBalance: number;
  Statement: ITransactionItem[];
}

export interface ILinkedGpayAccount {
  id: ID;
  withdrawableAmounts: IAccountWithdrawableAmounts[];
  company: ICompany;
  accounts: IGpayAccount[];
}

export interface IWithdrawalRequests {
  id: ID;
  transactionName: String;
  amount: number;
  approved: Boolean;
}

export interface IAccountWithdrawableAmounts {
  id: ID;
  transactionName: String;
  amount: number;
  availableBalance: number;
  withdrawalRequests: IWithdrawalRequests[];
}

export interface IUpdateFdFarm {
  name?: string;
  description?: string;
  directions?: string;
  numberOfLeasedHectares?: number;
  ownedHectares?: number;
  isLeased?: boolean;
  fullTimeFarming?: boolean;
  farmArrangement?: EFarmArrangement;
  irrigatedHectares?: number;
  drylandHectares?: number;
  leaseEndDate?: string | number;
  river?: boolean;
  dam?: boolean;
  borehole?: boolean;
  applyingUserId?: number;
  farmId?: number;
  waterRights?: boolean;
  shortTermGoals?: string;
  longTermGoals?: string;
  landComposition?: string;
  workforceNumber?: number;
  workerTrust?: string;
  employmentBeforeAndAfter?: string;
}

export interface ISaveFdProductionPlanDto {
  id?: number;
  cropId: number;
  numberOfHectares: number;
  estimatedYield: number;
  plantingDate?: Date | string;
  harvestYear?: number | null;
  harvestMonth?: number | null;
  notes?: String;
  irrigation?: EIrrigation;
  plantPopulation?: number;
  estimatedPrice?: number;
  applicationId?: number;
  areaOfDryLand?: number;
  areaUnderIrrigation?: number;
}

export interface ISaveFdProductionHistory {
  id?: number;
  cropId: number;
  numberOfHectaresFarmed: number;
  yieldPerHectare: number;
  year: number;
  farmId?: number | null;
  applicationId: number;
  notes?: string;
  plantYear?: number | null;
  plantMonth?: number | null;
  harvestYear?: number | null;
  harvestMonth?: number | null;
}

export interface ISaveFdFinancialPerformance {
  year: number;
  revenue: number;
  expenses: number;
  operatingCosts?: number;
  profit: number;
  financialYearEnd?: number;
  financialYearEndMonth?: number;
  companyId: number;
  applicationId: number;
  notes?: string;
}

export interface ISaveFdDoc {
  documentType: EDocType;
  filePath: string;
  applicationId: number;
}

export interface ISaveFdOperatingCost {
  id?: number;
  monthlyCosts: string;
  year: number;
  expenseId: number;
  applicationId: number;
  notes?: string;
}

export interface ISaveFdFarmAsset {
  id?: number;
  description?: string;
  year?: string;
  condition?: EAssetCondition;
  value?: number;
  pricePerUnit?: number;
  farmId?: number;
  capacity?: string;
  model?: string;
  make?: string;
  assetType?: EAssetType;
  assetListId: number;
  applicationId: number;
}
/* -------------------------------------------------------------------------- */
/*  AI-generated Business-plan                                                */
/* -------------------------------------------------------------------------- */
export interface IAiBusinessPlan {
  /* ---------- plain strings ---------- */
  executiveSummary: string;
  applicationStrengths: string[];
  applicationWeaknesses: string[];

  /* ---------- simple objects ---------- */
  companyOverview: {
    owner: string;
    experience: string;
    farmName: string;
    landDetails: string;
    waterRights: boolean;
  };

  /* ---------- list with description & content ---------- */
  assets: Described<{
    name: string;
    value: string | number;
    year: string;
    condition: string;
  }>;
  liabilities: Described<{
    name: string;
    limit: number;
    balance: number;
    installment: number;
  }>;
  fundingRequest: Described<{name: string; value: string | number}>;
  productionPlan: Described<{
    crop: string;
    hectares: number;
    plantingDate: string;
    plantPopulationPerHectare: number;
    irrigation: string;
    // eslint-disable-next-line @typescript-eslint/naming-convention
    estimatedYieldTPerHectare: number;
    estimatedPricePerT: number;
  }>;
  productionCosts: Described<{name: string; value: string | number}>;
  operatingCosts: Described<{name: string; value: string | number}>;
  financialProjections: Described<{
    revenue: number;
    costs: number;
    netProfit: number;
  }>;
  team: Described<{name: string; role: string}>;
  customers: Described<{name: string; crops: string[]}>;
  suppliers: {name: string; crops: string[]}[];

  /* ---------- nested array with description ---------- */
  productionHistory: Described<{
    year: number;
    crop: string;
    hectares: number;
    yield: number;
  }>;
  financialHistory: Described<{
    year: number;
    revenue: number;
    costs: number;
    netProfit: number;
  }>;

  /* ---------- mitigation & conclusion ---------- */
  applicationMitigation: {
    description: string;
    content: {risk: string; mitigation: string}[];
  };
  conclusion: {
    description: string;
    recommendations: string;
  };
}

/* -------------------------------------------------------------------------- */
/*  Re-usable helper                                                          */
/* -------------------------------------------------------------------------- */
type Described<T> = {
  description: {risks?: string; strengths?: string; notes?: string};
  content: T | T[];
};

export interface ISaveLiability {
  id?: number;
  creditLimitAmount: number;
  currentBalanceLimit: number;
  monthlyInstallmentAmount: number;
  inArrears: boolean;
  liabilityAccountTypeId: number;
  lender: string;
  applicationId: number;
}

export interface ISaveProductionCost {
  id?: number;
  plantingDate: string;
  year: number;
  numberOfHectares: number;
  seed: number;
  fertiliser: number;
  chemical: number;
  notes?: string;
  cropId: number;
  applicationId: number;
}

export interface IFarmTeam {
  id: number;
  name: string;
  description?: string;
  farmTeamRole: {
    id: number;
    name: string;
  };
}

export interface ICustomerSupplier {
  id: number;
  crop: IGenericType; // { id:number; name:string }
  customer: IGenericType; // { id:number; name:string }
}

export interface IFarmRiskBasic {
  id: number;
  name: string;
}

export interface IFarmRiskByApp {
  id: number;
  mitigation: string;
  problem: string;
  risk: {id: number; name: string};
}

export interface ICreateFarmRiskDto {
  id?: number; // present when editing
  riskId: number;
  mitigation: string;
  problem: string;
  applicationId: number;
}

export interface IRunItcTraderApplicationDto {
  name: string;
  surname: string;
  idNumber: string;
  externalServiceRequest: boolean;
}

export interface IitcDoc {
  personName: string;
  personSurname: string;
  finalDocLink: string;
  rawDataLink: string;
  requester: {id: string; name: string};
  requestedOn: string;
}

export interface ICompanyItcDoc {
  id: string;
  companyName: string;
  companyRegNumber: string;
  finalDocLink: string;
  rawDataLink: string;
  requester: {id: string; name: string};
  requestedOn: string;
}

export interface IPerformCompanyCreditCheckDto {
  regNumber1: string;
  regNumber2: string;
  regNumber3: string;
  refresh: boolean;
}

export interface IWidget {
  id: string;
  supplierId: string;
  name: string;
  x: number;
  y: number;
  width: number;
  height: number;
}

export interface IWidgetInput {
  id: string;
  name: string;
  x: number;
  y: number;
  width: number;
  height: number;
}
export interface IFdFinancialRatios {
  applicationId: number;
  ltv?: number | null;
  dscr?: number | null;
  grossMargin?: number | null;
  netProfitMargin?: number | null;
  debtToEquity?: number | null;
  interestCover?: number | null;
}

export interface IFdApplicationAuditLog {
  id: number;
  applicationId: number;
  application?: IFdApplicationType;
  changedBy?: number;
  field?: string;
  fromValue?: string;
  toValue?: string;
  changedAt?: string;
}

export interface ITopInputProduct {
  productId: string | number;
  stockCode?: string;
  productName: string;
  totalUnits: number;
}

export interface IFdFarmerProvinceBreakdown {
  province: string;
  farmerCount: number;
}

export interface IFdFarmerCropBreakdown {
  crop: string;
  farmerCount: number;
}

export interface IFdFarmerSummary {
  totalFarmerCount: number;
  avgFarmSizeHectares: number;
  provinceBreakdown: IFdFarmerProvinceBreakdown[];
  cropBreakdown: IFdFarmerCropBreakdown[];
}

export type IWalletMetricsPeriod = 'WEEK' | 'MONTH' | 'YEAR';

export interface IWalletMetrics {
  totalWallets: number;
  totalBalance: number;
  totalSpend: number;
  transactionCount: number;
}

export interface IProgramTypeBreakdown {
  type: string;
  count: number;
}

export interface IProgramStatusBreakdown {
  status: string;
  count: number;
}

export interface IProgramCropBreakdown {
  crop: string;
  count: number;
}

export interface IProgramSummary {
  totalCount: number;
  typeBreakdown: IProgramTypeBreakdown[];
  statusBreakdown: IProgramStatusBreakdown[];
  cropBreakdown: IProgramCropBreakdown[];
  totalValue: number;
}

export interface IQuoteStatusCount {
  state: number;
  label: string;
  count: number;
}

export interface IQuoteDepotBreakdown {
  depotId: number;
  depotName: string;
  count: number;
}

export interface IQuoteValueTimeline {
  date: string;
  totalValue: number;
}

export interface IQuoteSummary {
  needsAttention: IFarmInputQuote[];
  statusCounts: IQuoteStatusCount[];
  depotBreakdown: IQuoteDepotBreakdown[];
  valueTimeline: IQuoteValueTimeline[];
}

export interface IQuoteConversionRate {
  totalQuotes: number;
  acceptedQuotes: number;
  rejectedQuotes: number;
  conversionRate: number;
}

export interface IFavouriteProduct {
  productId: string;
  stockCode: string;
  productName: string;
  currentPrice: number;
  previousPrice: number;
  priceChangedAt: string;
  favouriteCount: number;
}

// ─── Groups Feature ────────────────────────────────────────────────────────────

export interface IGroupOwner {
  userId: number;
  username: string;
}

export interface IGroup {
  uuid?: string;
  groupId: string;
  name: string;
  description?: string;
  image?: string;
  avatar?: string;
  isPrivate: boolean;
  createdAt: string;
  createdBy?: IGroupOwner;
  admins?: IGroupOwner[];
  members?: IGroupOwner[];
  // Additional optional fields used by the UI
  memberCount?: number;
  isArchived?: boolean;
  visibility?: string;
  owner?: IGroupOwner;
}

export interface IGroupMember {
  userId: number;
  username: string;
  avatar?: string;
  phone?: string;
  isOnline?: boolean;
}

export interface IGroupMembersResponse {
  members: IGroupMember[];
  total: number;
  page: number;
  limit: number;
  totalPages: number;
  hasNextPage: boolean;
  hasPreviousPage: boolean;
}

export interface IGroupRoleMember {
  userId: number;
  username: string;
  isOwner: boolean;
}

export interface IGroupRoles {
  groupId: string;
  groupName: string;
  owner: IGroupRoleMember;
  admins: IGroupRoleMember[];
  members: IGroupRoleMember[];
}

export interface IGroupActionResponse {
  success: boolean;
  message: string;
}

export interface IGroupInvitationCode {
  invitationCode: string;
  inviteCodeExpiryDate: string;
}

export interface IGroupMessage {
  uuid: string;
  content: string;
  type: string;
  isEdited: boolean;
  isDeleted: boolean;
  createdAt: string;
  sender: {
    userId: number;
    username: string;
    avatar: string;
  };
}

export interface ICreateGroupInput {
  name: string;
  description?: string;
  isPrivate: boolean;
}

export interface ICreateGroupResponse {
  groupId: string;
  name: string;
  description?: string;
  isPrivate: boolean;
  members: Array<{userId: number; username: string}>;
  admins: Array<{userId: number; username: string}>;
  createdBy: {userId: number; username: string};
}
